<template>
  <v-container class="overview-page" v-show="!isFetchingCode">
    <v-row>
      <v-col class="pa-0">
        <h2 v-show="$vuetify.breakpoint.smAndUp" class="primary--text font-weight-bold pt-5 px-5 mb-0">
          {{ code.facilityName }}
        </h2>
        <h4 v-show="$vuetify.breakpoint.xsOnly" class="primary--text font-weight-bold pt-5 px-5 mb-0">
          {{ code.facilityName }}
        </h4>

        <QRCodeFacilityTable
            ref="table"
            v-if="assignQRCode"
            @setQRCodeToFacility="setQRCodeToFacility"
        />

        <QRCodeFacilityData
          ref="data"
          v-else
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QRCodeService from "@/modules/book/services/qrcode-service";
import QRCode from "@/modules/book/data/qrcode";
import QRCodeFacilityTable from "@/modules/book/views/public/QRCodeFacilityTable";
import QRCodeFacilityData from "@/modules/book/views/public/QRCodeFacilityData";
import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import Facility from "@/modules/book/data/facility";
import PublicQRCodeData from "@/modules/book/data/public-qrcode-data";

export default {
  name: "QRCodeFacilityOverview",
  components: {
    QRCodeFacilityTable,
    QRCodeFacilityData
  },
  data() {
    return {
      code: new QRCode(),
      assignQRCode: false,

      isFetchingCode: true
    }
  },
  methods: {
    setQRCodeToFacility(facility){
      QRCodeService.assignFacilityToCode(this.$route.params.code, facility,
        () => {
          this.assignQRCode = false;
          this.$nextTick(() => {
            this.setupDataView();
          });
        },
        (error) => {
          this.$logger.error("Failed assigning qrcode to code " + this.$route.params.code +", because: " + error);
          Utils.showFailureSnackbar(this.$t('book/public:qrcode.snackbar.assign-failure'));
        }
      )
    },

    setupQRCodeAssignment(){
      QRCodeService.readFacilitiesFromPublic(this.$route.params.code,
        (data) => {
          this.assignQRCode = true;
          //after the child renders, we have to wait 1 tick until we can access it
          this.$nextTick(() => {
            this.$refs.table.content = DataUtils.parseDataToObjectArray(data.data, Facility);
          });
        },
        (error) => {
          this.$logger.error("Failed loading facilities for code " + this.$route.params.code +", because: " + error);
          this.$router.push('/404');
        }
      )
    },

    setupDataView(){
      QRCodeService.readDataFromPublic(this.$route.params.code,
        (data) => {
          this.$refs.data.initialise(DataUtils.parseDataToSingleObject(data.data, PublicQRCodeData));
        },
        (error) => {
          this.$logger.error("Failed loading data for code " + this.$route.params.code +", because: " + error);
          this.$router.push('/404');
        }
      )
    }
  },
  created() {
    this.$logger.info("Accessed public qr-code page: " + this.$route.params.code);
    //check if qrcode at the current page exists
    QRCodeService.readCodeFromPublic(this.$route.params.code,
      (code) => {
        this.isFetchingCode = false;
        //if does, check qrcode data for further info
        this.code = DataUtils.parseDataToSingleObject(code.data, QRCode);
        if(!this.code.facility){
          this.setupQRCodeAssignment();
        }
        else {
          this.setupDataView();
        }
      },
      (error) => {
        this.$logger.error("Attempted to access public qrcode page, but failed: " + error);
        this.$router.push('/404');
      }
    )
  }
}
</script>
<style src="@/modules/book/views/public/QRCodePublic.scss" lang="scss"/>
